import { graphqlApi } from '@/graphql'
import { baseApi } from '@/services'
import { AppraisalOrder, Valuation } from '@/types/unlock'

/**
 * AppraisalOrder
 */
export const appraisalOrderApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAppraisalOrder: builder.query<AppraisalOrder[], Partial<AppraisalOrder>>({
      query: (params) => ({
        method: 'GET',
        url: `v2/appraisal-order/`,
        params: params,
      }),
      providesTags: ['AppraisalOrder'],
    }),
    createAppraisalOrder: builder.mutation<AppraisalOrder, Partial<AppraisalOrder>>({
      query: (body) => ({
        method: 'POST',
        url: 'v2/appraisal-order/',
        body,
      }),
      invalidatesTags: [
        'AppraisalOrder',
        'Application',
        'ApplicationOffer',
        'ApplicationGuidelines',
        'ApplicationCalcs',
        'MaxActions',
        'ListOfNotes',
      ],
    }),
    createAppraisalReport: builder.mutation<AppraisalOrder, Partial<AppraisalOrder>>({
      query: (body) => ({
        method: 'POST',
        url: 'v2/appraisal-report/',
        body,
      }),
      invalidatesTags: [
        'AppraisalOrder',
        'Application',
        'ApplicationOffer',
        'ApplicationGuidelines',
        'ApplicationCalcs',
        'MaxActions',
        'ListOfNotes',
        'Alert',
      ],
    }),
    updateAppraisalReport: builder.mutation<Valuation, Partial<Valuation>>({
      query: (valuation) => ({
        method: 'PATCH',
        url: `v2/appraisal-report/${valuation.uuid}/`,
        body: valuation,
      }),
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        await queryFulfilled
        dispatch(graphqlApi.util.invalidateTags(['gql:applicationValuationsCalcs']))
      },
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'AutomatedApplicationExceptions',
        'ValuationV2',
        'AtypicalityCheckCalcs',
        'ApplicationGuidelines',
        'ApplicationCalcs',
        'ValuationV2',
        'Escalations',
        'Alert',
      ],
    }),
  }),
})

export const {
  useGetAppraisalOrderQuery,
  useCreateAppraisalOrderMutation,
  useCreateAppraisalReportMutation,
  useUpdateAppraisalReportMutation,
} = appraisalOrderApi
